/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Railcollapse1Inputs */

const en_railcollapse1 = /** @type {(inputs: Railcollapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse menu`)
};

const de_railcollapse1 = /** @type {(inputs: Railcollapse1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü einklappen`)
};

/**
* | output |
* | --- |
* | "Collapse menu" |
*
* @param {Railcollapse1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const railcollapse1 = /** @type {((inputs?: Railcollapse1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Railcollapse1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_railcollapse1(inputs)
	return de_railcollapse1(inputs)
});
export { railcollapse1 as "railCollapse" }